import { Constant } from '../utils/constant';

export class ConvertUnits {
  public static convertByteToMb(bytes: number): number {
    const kb = bytes / Constant.UNIT_BYTE;
    return kb / Constant.UNIT_BYTE;
  }
}
